export default {
  zh: {
    registerTitle: '注册',
    emailPlaceholder: '邮箱',
    pwPlaceholder: '密码',
    affirmPwPlaceholder: '确认密码',
    emailHint: '请输入邮箱',
    passwordHint: '请输入密码',
    affirmPasswordHint: '请输入确认密码',
    inconformity: '两次输入的密码不一致',
    succeed: '注册成功',
    receiptLanguage: '选择收件语言'
  },
  en: {
    registerTitle: 'Register',
    emailPlaceholder: 'Email',
    pwPlaceholder: 'Password',
    affirmPwPlaceholder: 'Confirm password',
    emailHint: 'Please enter your email',
    passwordHint: 'Please enter your password',
    affirmPasswordHint: 'Please enter your password again',
    inconformity: 'Entered passwords differ',
    succeed: 'Registered successfully',
    receiptLanguage: 'Email language'
  }
}
